import '../../styles/index.css'
import './SobreNos.css';
import Location from '../../components/Location/Location';
import { devs } from '../../utils/devs';
import CardDev from '../../components/Cards/CardDev/CardDev';

function SobreNos() {
  return (
    <main className='sobreNos'>

      <div className='page-container'>
        <Location local='Sobre Nós' />
      </div>


      <section className='mt-2 d-flex flex-column gap-3 page-container'>
        <h5 className='text-center'>Sobre nós</h5>
        <p>O OnPrice é o primeiro comparador brasileiro de preços focado 100% em computadores.</p>

        <p>Com a alta frequente dos preços de hardware dentro e fora do Brasil, 4 estudantes de
          Ciência da Computação decidiram criar um comparador que fosse útil tanto para aqueles que já possuem conhecimento na área, quanto para aqueles estão montando seu primeiro computador.
        </p>

        <p>Para uma navegação e montagem de Setup melhores, a plataforma também trabalha com compatibilidade de peças. Logo, conforme você monta seu próximo PC no OnPrice, lhe mostraremos apenas aquelas peças compatíveis com sua seleção atual.
        </p>
      </section>

      <section className='quemSomos'>

        <div className='divEquipe shadow mt-5'>

          <h5 style={{ color: 'white' }}>Quem somos?</h5>

          <div className='mt-4 d-flex flex-wrap gap-3'>
            {
              devs.map((dev) => {
                return (
                  <CardDev
                    key={dev.id}
                    nome={dev.nome}
                    email={dev.email}
                    foto={dev.foto}
                    cargo={dev.cargo}
                    portfolio={dev.github ? dev.github : dev.behance}
                    linkedin={dev.linkedin}
                  />
                )
              })
            }
          </div>

        </div>

      </section>

    </main>
  );
}

export default SobreNos;
